import { useEffect, useState } from 'react';
import { InputSize, InputText } from '@ui/src';
import {
  AccountsFlowsFormValues,
  NewApplicationStatus,
} from '../../../../hoc/new-application/types';
import { AccountFlowTypes } from '../types';
import InfoRow from '../info-row';

import cn from '../styles.module.css';

const AccountFlow = ({
  accountFlow,
  accountsFlows,
  setAccountsFlowsValues,
  currencies,
  status,
  isEditable,
  currenciesList,
}: AccountFlowTypes) => {
  const [formValues, setFormValues] = useState<AccountsFlowsFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = accountsFlows?.map((item) => {
      const result = { ...item };
      const nextFormValues = { ...formValues };

      if (nextFormValues.id === item.id) {
        if (e.target.name === `expectedAnnualCreditTurnover-${item.id}`) {
          nextFormValues.expectedAnnualCreditTurnover = e.target.value;
          result.expectedAnnualCreditTurnover = e.target.value;
        } else if (
          e.target.name === `maxTransferAmountPerTransaction-${item.id}`
        ) {
          nextFormValues.maxTransferAmountPerTransaction = e.target.value;
          result.maxTransferAmountPerTransaction = e.target.value;
        } else if (e.target.name === `transactionFrequency-${item.id}`) {
          nextFormValues.transactionFrequency = e.target.value;
          result.transactionFrequency = e.target.value;
        } else if (
          e.target.name === `transactionFrequencyPeriodMonths-${item.id}`
        ) {
          nextFormValues.transactionFrequencyPeriodMonths = e.target.value;
          result.transactionFrequencyPeriodMonths = e.target.value;
        }

        setFormValues(nextFormValues as AccountsFlowsFormValues);
      }

      return result;
    });

    setAccountsFlowsValues(nextValues as AccountsFlowsFormValues[]);
  };

  useEffect(() => {
    if (accountFlow) {
      setFormValues(accountFlow);
    }
  }, [accountFlow]);

  return (
    <div className={cn.accountFlow}>
      <div className={cn.accountFlowTop}>
        <div className={cn.accountFlowCurrency}>
          {
            currencies?.find((item) => item.value === accountFlow?.currencyId)
              ?.suffix
          }
        </div>
        <div className={cn.accountFlowTransactionType}>
          {`${accountFlow?.transactionType?.charAt(0)}${accountFlow?.transactionType?.slice(1).toLowerCase()} transactions`}
        </div>
      </div>
      <div className={cn.accountFlowContent}>
        <InfoRow title="Expected annual credit turnover" lessPadding>
          <InputText
            name={`expectedAnnualCreditTurnover-${accountFlow?.id}`}
            placeholder="Enter amount..."
            value={formValues?.expectedAnnualCreditTurnover}
            onChange={(e) => {
              onChange({
                ...e,
                target: {
                  ...e.target,
                  name: `expectedAnnualCreditTurnover-${accountFlow?.id}`,
                },
              });
            }}
            className="borderless"
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            size={InputSize.SMALL}
            currency={currenciesList?.find(
              (item) => item.id === accountFlow?.currencyId,
            )}
            amountInput
          />
        </InfoRow>
        <InfoRow title="Max. transfer amount per transaction" lessPadding>
          <InputText
            name={`maxTransferAmountPerTransaction-${accountFlow?.id}`}
            placeholder="Enter amount..."
            value={formValues?.maxTransferAmountPerTransaction}
            onChange={(e) => {
              onChange({
                ...e,
                target: {
                  ...e.target,
                  name: `maxTransferAmountPerTransaction-${accountFlow?.id}`,
                },
              });
            }}

            className="borderless"
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            size={InputSize.SMALL}
            currency={currenciesList?.find(
              (item) => item.id === accountFlow?.currencyId,
            )}
            amountInput
          />
        </InfoRow>
        <InfoRow title="Frequency of transactions (months)" lessPadding>
          <div className={cn.accountFlowFlexRow}>
            <div className={cn.accountFlowFlexValue}>
              <InputText
                name={`transactionFrequency-${accountFlow?.id}`}
                placeholder="Enter number of transactions..."
                value={formValues?.transactionFrequency}
                onChange={onChange}

                className="borderless"
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                size={InputSize.SMALL}
              />
            </div>
            <div className={cn.accountFlowFlexRowSeparator}>per</div>
            <div className={cn.accountFlowFlexValue}>
              <InputText
                name={`transactionFrequencyPeriodMonths-${accountFlow?.id}`}
                placeholder="Number of months..."
                value={formValues?.transactionFrequencyPeriodMonths}
                onChange={onChange}

                className="borderless"
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                size={InputSize.SMALL}
              />
            </div>
          </div>
        </InfoRow>
      </div>
    </div>
  );
};

export default AccountFlow;
